import { Inject, Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';

// RXJS
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

// Ionic
import { LoadingController } from '@ionic/angular';

// Abstracts
import { HTTP_PRESENTAION_URL, NgInternalLinkService, NgPostTypeProvider, NgToastService } from '../abstracts';

// Interfaces
import { IPostType } from 'projects/models/src/public-api';

@Injectable()
export class InternalLinkService implements NgInternalLinkService {

  constructor(
    @Inject(HTTP_PRESENTAION_URL)
    private url: string,
    private postTypeProvider: NgPostTypeProvider<IPostType>,
    private toastService: NgToastService,
    private router: Router,
    private loadingController: LoadingController,
    private zone: NgZone) { }

  public async check(link: string): Promise<any> {
    if (link.startsWith(this.url)) {
      const loading = await this.loadingController.create({ translucent: true });
      loading.present();

      let slug = link.split(this.url).pop();

      if (slug === "/datenschutzerklaerung") {
        this.open('datenschutzerklaerung', 'page')
          .finally(() => loading.dismiss());
      }
      else if (slug === "/urlaubsantrag") {
        this.open('leave-request', 'organization')
          .finally(() => loading.dismiss());
      }
      else {
        const id = this.extractPostIdFromUrl(slug);
        const postType = await this.getPostType(id);
        this.open(postType.id, postType.type)
          .finally(() => loading.dismiss());
      }
    }
    else {
      return new Promise((reject) => {
        const error = new Error('Link not matching pattern!');
        this.handleError(error);
        reject(error);
      });
    }
  }

  public async checkId(id: string): Promise<any> {
    const loading = await this.loadingController.create({ translucent: true });
    loading.present();
    this.getPostType(id)
      .then((postType: IPostType) => {
        this.open(postType.id, postType.type);
      })
      .catch((error) => this.handleError(error))
      .finally(() => loading.dismiss());
  }

  private extractPostIdFromUrl(url: string): string {
    if (url.includes('?p=')) {
      return url.split('?p=')[1];
    }
    else {
      return url.split('/').pop();
    }
  }

  private getPostType(id: string): Promise<IPostType> {
    return (this.postTypeProvider.get(`/wp-json/com-on/v1/post-types/${id}`) as Observable<IPostType>)
      .pipe(take(1))
      .toPromise();
  }

  private async getCurrentPath(): Promise<any> {

    const tree = this.router.url.split('/');
    return tree;

    // const currentId = this.extractPostIdFromUrl(this.router.url);
    // const currentPost = await this.getPostType(currentId)
    //   .then((x: IPostType) => {return x;})
    //   .catch((error) => this.handleError(error));

    // return this.createPath(currentPost.id, currentPost.type);
  }

  private async open(id: number | string, type: string): Promise<any> {
    const path = this.createPath(id, type);
    const previousPath = await this.getCurrentPath();

    return this.zone.run(() => {
      return this.router.navigate(path, {state: { data: { previousPath: previousPath }}})
        .catch((error) => this.handleError(error));
    });
  }

  private createPath(id: string | number, type: string): any[] {
    let path: any[];
    switch (type) {
      case 'post':
        path = ['posts', id];
        break;
      case 'organization':
        path = ['organization', id];
        break;
      case 'workshop':
        path = ['workshop', id];
        break;
      case 'benefit':
        path = ['benefit', id];
        break;
      default:
        path = ['page', id];
        break;
    }
    return path;
  }

  private handleError(error: any): any {
    this.toastService.error({ message: 'Inhalt konnte nicht geladen werden!' })
      .then((toast) => {
        toast.present();
      })
      .finally(() => { return error; });
  }

}
